// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AppService } from '../../../app.service';


@Component({
    selector: 'me-landing-page-quote',
    templateUrl: './landing-page-quote.component.html',
    styleUrls: ['./landing-page-quote.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class MeLandingPageQuoteComponent implements OnInit {
    @Input() data : any = {};

    hidePrev = true;
    hideNext = false;
    customOptions: OwlOptions = {
        items: 1,
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
    }

    constructor(
        public appService: AppService
    ) {
       
    }

    ngOnInit() {
    }

    getDataCarousel(data) {
        let length = this.data['quotes'].length;
        this.hideNext = data.startPosition === (length - 1) ? true : false;
        this.hidePrev = data.startPosition === 0 ? true : false;
    }
}
